module.exports = __webpack_public_path__ + "img/logo.b65172c0.png";